export const SITE_DIRECTION_CSS_VAR = 'var(--wix-opt-in-direction, ltr)';
export const withSiteDirection = (direction) => direction === 'inherit' ? SITE_DIRECTION_CSS_VAR : direction;
//# sourceMappingURL=withSiteDirection.js.map